import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { COLOR, getColorClassName } from 'utilsTS/color';

import styles from './ColorDecoration.module.scss';

export enum DECORATION_POSITION {
    TOP = 'top',
    RIGHT = 'right',
    BOTTOM = 'bottom',
    LEFT = 'left',
}

export interface ColorDecorationProps extends React.ComponentPropsWithoutRef<'span'> {
    /** Defines the colour of the component */
    color?: COLOR;
    /** Defines hex colour override */
    colorValue?: string;
    /** Defines which edge should the component face */
    position?: DECORATION_POSITION;
}

export interface ColorDecorationStatics {
    COLOR: typeof COLOR;
    POSITION: typeof DECORATION_POSITION;
}

export const ColorDecoration: React.FC<ColorDecorationProps> & ColorDecorationStatics = ({
    color,
    colorValue,
    className,
    position = DECORATION_POSITION.LEFT,
    style,
    ...rest
}) => {
    if (!color && !colorValue && !className?.includes('g-bg-')) return null;

    const bgStyle = color ? {} : ({ '--color-bg': colorValue } as React.CSSProperties);
    const bgClassName = colorValue ? '' : getColorClassName(color);

    return (
        <span
            {...rest}
            aria-hidden
            style={{ ...style, ...bgStyle }}
            className={cx(className, styles.decoration, styles[position], bgClassName)}
        />
    );
};

ColorDecoration.COLOR = COLOR;
ColorDecoration.POSITION = DECORATION_POSITION;

ColorDecoration.displayName = 'ColorDecoration';
ColorDecoration.propTypes = {
    color: PropTypes.oneOf(Object.values(ColorDecoration.COLOR)),
    colorValue: PropTypes.string,
    className: PropTypes.string,
    position: PropTypes.oneOf(Object.values(ColorDecoration.POSITION)),
    style: PropTypes.shape({}),
};
